import { useChallengeBoost } from '~/components/Challenge/Boost/ChallengeBoost.hooks';
import boost from '~/components/Icon/boost.png';
import { useMember } from '~/components/Member/Member.hooks';
import { QuickMenuItem, QuickMenuItemProps } from '~/components/Quick/Menu/QuickMenuItem';
import { formatBoost } from '~/components/Util/number';

export type ChallengeGuideQuickMenuItemProps = Partial<QuickMenuItemProps>;

export const ChallengeBoostQuickMenuItem = (props: ChallengeGuideQuickMenuItemProps) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const {
    data: { totalBoost },
    isInitialLoading,
  } = useChallengeBoost({ useErrorBoundary: false });

  return (
    <QuickMenuItem
      {...props}
      image={boost}
      label="Boost"
      description={
        isLoggedIn ? `${formatBoost(totalBoost, { zeroAsEmpty: isInitialLoading })}%` : null
      }
    />
  );
};
